import { render } from "./ReportForwardBtn.vue?vue&type=template&id=593dc496"
import script from "./ReportForwardBtn.vue?vue&type=script&lang=js"
export * from "./ReportForwardBtn.vue?vue&type=script&lang=js"

import "./ReportForwardBtn.vue?vue&type=style&index=0&id=593dc496&lang=css"

import exportComponent from "/builds/cu2207/business/produkter.dk/pfp-public-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__